import ApiClient from '@/api/ApiClient';
import Cart from '@/api/models/Cart';
import Collection from '@/helpers/Collection';

class CartService {
    #prefixUrl = 'api/cart/';

    constructor() {
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Gets logged user cart
     * @return {Response}
     */
    async getMyCart() {
        const response = await this.api.executeRequest(`/`, {}, this.api.methods.GET);
        if (response.success()) {
            let data = [];
            for (let item of response.getContent()) {
                data.push(new Cart(item));
            }
            response.setContent(new Collection(data, 'course'));
        }
        return response;
    }

    /**
     * Get number of remaining attemps of the User to answer a question 
     * @param {String} courseUuid
     * @returns {Response}
     */
    async addToCart(courseUuid = null) {
        const response = await this.api.executeRequest(`/add/${courseUuid}`, {}, this.api.methods.POST);
        if (!response.success())
            return null;
        return response.getContent();
    }

    /**
     * Get number of remaining attemps of the User to answer a question 
     * @param {String} courseUuid 
     * @returns {Response}
     */
    async removeFromCart(courseUuid = null) {
        const response = await this.api.executeRequest(`/remove/${courseUuid}`, {}, this.api.methods.POST);
        if (!response.success())
            return null;
        return response.getContent();
    }
}

export default new CartService();
